/**
 * RESPONSIBILITY: draw a block of a picture and words one above the other.
 *
 * Same reasoning as AdcSplit: the two templates differ by which child comes first. The
 * picture runs the full width of the column, so it reads as a banner for the words.
 */
import { Html } from '@framework/react';
import { hasImage } from '@framework/core';
import { ADC_THEME } from '@app/sections';
import { AdcBand } from './AdcBand';
import { Picture } from '../commons/Picture';
import type { AdcBlockProps } from './kind';

function Stacked({ b, imageFirst }: AdcBlockProps & { imageFirst: boolean }) {
  const pic = hasImage(b.image) ? <Picture key="p" value={b.image} className="adc-pic adc-pic-wide" /> : null;
  const words = b.bodyHtml ? <Html key="w" className="md-body adc-copy adc-copy-centre">{b.bodyHtml}</Html> : null;
  if (!pic && !words) return null;

  return (
    <AdcBand theme={imageFirst ? ADC_THEME.ImageTop : ADC_THEME.TextTop} heading={b.heading}>
      {imageFirst ? [pic, words] : [words, pic]}
    </AdcBand>
  );
}

export const AdcImageTop = (p: AdcBlockProps) => <Stacked {...p} imageFirst />;
export const AdcTextTop = (p: AdcBlockProps) => <Stacked {...p} imageFirst={false} />;
